<template>
  <div class="Activity">
    <div class="top">
      <!-- <el-button
        @click="$refs.DialogEdit.toInsert()"
        class="pull-right"
        type="primary"
        icon="el-icon-circle-plus-outline"
      >添加推荐</el-button>-->
      门店<el-select v-model="searchFendian" style="width: 200px;margin-right:10px;">
        <el-option
          v-for="item in columnArr"
          :key="item.ifdFendianId"
          :label="item.cfdFendianName"
          :value="item.ifdFendianId">
        </el-option>
      </el-select>
      关键字<el-input
        @keyup.enter.native="getActive()"
        v-model="searchValue"
        @clear="getActive()"
        placeholder="请输入关键字搜索"
        clearable
        style="width:220px;margin-right:10px;"
      ></el-input>
      <el-button @click="getActive()" type="primary" icon="el-icon-search">搜索</el-button>
      <el-checkbox v-model="isShowMP" @change="getActive()" style="margin-left:15px;">员工作品显示</el-checkbox>
      <el-checkbox v-model="Recommend" @change="getActive()" style="margin-left:15px;">员工作品推荐</el-checkbox>
    </div>

    <div>
      <el-table :data="bannerData" style="width: 100%">
        <el-table-column prop="id" label="序号" align="center"></el-table-column>
        <el-table-column prop="OrderNo" label="显示顺序" align="center"></el-table-column>
        <el-table-column prop="cfdEmployeeId" label="员工编号"></el-table-column>
        <el-table-column prop="cfdEmployeeName" label="艺名" align="center"></el-table-column>
        <el-table-column prop="cfdWorksName" label="作品名称" align="center"></el-table-column>
        <el-table-column prop="cfdImgSrc" label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.ImageUrl" @click="goMap(scope.row.ImageUrl)">
          </template>
        </el-table-column>
        <el-table-column prop="dfdCreateTime" label="创建时间" align="center">
          <template
            slot-scope="scope"
            v-if="scope.row.dfdCreateTime"
          >{{scope.row.dfdCreateTime.split('T')[0]}}</template>
        </el-table-column>
        <el-table-column prop="RecommendEndDate" label="推荐结束日期" align="center">
          <template
            slot-scope="scope"
            v-if="scope.row.RecommendEndDate"
          >{{scope.row.RecommendEndDate.split('T')[0]}}</template>
        </el-table-column>

        <el-table-column prop="name" label="员工作品是否显示" align="center">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.IsShow" @change="isShowItem(scope.row)"></el-checkbox>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="操作" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.row.date }} -->
            <el-button type="text" @click="$refs.DialogEdit.toEdit(scope.row)">修改</el-button>
            <!-- <el-button type="text" @click="delItem(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="getActive"
      @current-change="handleCurrentChange"
      background
      :current-page.sync="currentPage"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size.sync="limit"
      layout="total, sizes, prev, pager, next"
      :total="totalCount">
    </el-pagination>
    <DialogEdit ref="DialogEdit" @success="getActive()"/>
  </div>
</template>

<script>
import DialogEdit from "./DialogEdit";
import Pagination from '@/views/Pagination/index.vue'
export default {
  name: "home",
  data() {
    return {
      searchValue: "",
      isShowMP: false,
      Recommend: false,
      bannerData: [],
      searchFendian: "",
      columnArr: [],
      currentPage: 1, //当前页码
      limit: 30, //每页显示条数
      totalCount:0 //总页数
    };
  },
  created() {
    this.getActive();
    this.getShops();
  },
  methods: {
    getActive() {

      this.$axios
        .post(this.GLOBAL.baseURL + "Employee/PCQueryEmpWorksReList", {
          Keyword: this.searchValue,
          ifdFendianId: this.searchFendian,
          IsShow: this.isShowMP ? true : "",
          IsRecommend: this.Recommend ? true : "",
          pageIndex: this.currentPage,
          pageSize: this.limit
        })
        .then(res => {
          // console.log(res);
          if (Number(res.code) === 0) {
            this.bannerData = res.data;
            if(this.totalCount != res.count)
            {
              this.handleCurrentChange(1)
            }
            this.totalCount = res.count;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getActive();
    },
    getShops() {
      this.$axios
        .post(this.GLOBAL.baseURL + "FenDian/PCQueryFendianList", {
          Keyword: ""
        })
        .then(res => {
          if (Number(res.code) === 0) {
            // log(res.data)
            this.columnArr = res.data.filter(item => {
              return item.ifdType === 2;
            });
          } else {
            this.$message.error(res.msg);
            if (Number(res.code) === 301) {
              window.location.reload();
            }
          }
        });
    },
    // 是否显示开关
    isShowItem(item) {
      let isTrue = event.target.checked;
      log(item);
      // log(isTrue)
      // return
      this.$axios
        .post(this.GLOBAL.baseURL + "Employee/PCEditEmpWorksByShow", {
          ifdID: item.ifdID,
          IsShow: isTrue
        })
        .then(res => {
          // console.log(res);
          if (Number(res.code) === 0) {
            this.$message.success("修改成功！");
            this.getActive();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    delItem(item) {
      // log(item)
      this.$confirm("确定删除这条数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .get(this.GLOBAL.baseURL + "Employee/PCDelEmployee", {
              params: { cfdEmployeeId: item.cfdEmployeeId }
            })
            .then(res => {
              // console.log(res);
              if (Number(res.code) === 0) {
                this.getActive();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    goMap(item) {
      window.open(item);
    },
  },
  components: {
    DialogEdit,
    'myPagination': Pagination
  }
};
</script>

<style lang="less">
@import "./less.less";
</style>
